import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { HealthTestQuestionnaireFields } from "../../../types/components/healthTestQuestionaires.types";
import { request } from "../api";

const initialRoute = "member/personal-health-score";
const { post } = request;

type QuestionaireQueryPayload = {
	SSN: string;
	group_number: number;
};

export const addPersonalHealthScore = async (
	_payload: HealthTestQuestionnaireFields,
	queryPayload: QuestionaireQueryPayload
) => {
	try {
		const { SSN, group_number } = queryPayload;
		const endpoint = `${initialRoute}/add-personal-health-score?SSN=${SSN}&group_number=${group_number}`;
		const token = localStorage.getItem("@jwt_member");
		const payload = JSON.stringify(_payload);
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response) {
			// console.log("Response : ", response);
			const {
				data: { message, result }
			} = response;
			if (message === MESSAGE.post.succ) return result;
		}
	} catch (error) {
		alert(error);
	}
};
